import React from 'react';

const AssignAdjuRead = () => {
    return (
        <p>Assign Adjududication Read!!!</p>
    );
}
export default AssignAdjuRead;
